module.exports = __webpack_public_path__ + "img/secondary_7x3_z16.4d80a241.svg";